<div class="map-container">
  <!-- <div #mapInjectionTarget class="map-injection-target"></div> -->
  <iframe class="w-full h-full" [src]="mapUrl()" frameborder="0" allowfullscreen></iframe>
</div>
